import { ready } from "./ready.js";
import { initLQIP } from "./lqip.js";

// Lazy, code-split modules — kept out of the critical path.
import("./accessibility.js").then((m) => m.init());
import("./modal.js").then((m) => m.init());
import("./ajax-form.js").then((m) => m.init());
import("./require-any.js").then((m) => m.init());
import("./css-doodle.cjs");
import("./parallax.js").then((m) => m.init());
import("./pim.js").then((m) => m.init());
import("./hero-goo.js").then((m) => m.init());
import("./hero-text-goo.js").then((m) => m.init());

// Highlight.js is ~30 KB gzipped. Only pay for it on blog posts with code.
if (document.body.classList.contains("blog") && document.querySelector("pre")) {
  import("./syntax.js").then((m) => m.init());
}

ready(() => {
  initLQIP();

  const copy = document.getElementById("copy-year");
  if (copy) copy.textContent = new Date().getFullYear();

  // Prune legacy analytics cookies set by the old Tartan-era GA integration.
  const stale = ["_ga", "hide-cookie-notice", "_gid", "_gat"];
  for (const name of stale) {
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    document.cookie = `${name}=; domain=${location.hostname}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  }
});
